import type { PropertyListBucket, PropertyStatusCounts } from '../types/propertyTypes'

// The Properties list's five quick-filter cards (FSD 3.3.1), in display order.
// `bucket: null` is All properties — the absence of a filter, not a sixth bucket.
export interface PropertyListFilterCard {
  key: keyof PropertyStatusCounts
  label: string
  bucket: PropertyListBucket | null
}

export const PROPERTY_LIST_FILTERS: readonly PropertyListFilterCard[] = [
  { key: 'all', label: 'All properties', bucket: null },
  { key: 'inSetup', label: 'In setup', bucket: 'in_setup' },
  { key: 'onMarketplace', label: 'On Marketplace', bucket: 'on_marketplace' },
  { key: 'fullyFunded', label: 'Fully funded', bucket: 'fully_funded' },
  { key: 'settled', label: 'Settled', bucket: 'settled' },
]

// Column header labels, in the order the row renders its cells. The trailing ⋮
// column has no label.
export const PROPERTY_TABLE_COLUMNS = [
  { key: 'property', label: 'Property' },
  { key: 'location', label: 'Location' },
  { key: 'asking', label: 'Asking price' },
  { key: 'agreed', label: 'Agreed price' },
  { key: 'status', label: 'Status' },
  { key: 'approved', label: 'Approved for setup' },
] as const

// Column widths, shared by the table header and every row.
export const PROPERTY_GRID_TEMPLATE =
  'minmax(0, 2.2fr) minmax(0, 1.4fr) minmax(0, 1.3fr) minmax(0, 1.3fr) minmax(0, 1.3fr) minmax(0, 1.1fr) 40px'

// How long the search box waits after the last keystroke before asking the server.
export const PROPERTY_SEARCH_DEBOUNCE_MS = 300
